/**
 * Strip technical id markers (`\t__bid:<n>`, `\t__sid:<n>`, `\t__aid:<n>`)
 * emitted by `BranchTextParser` for the Selective Edit round-trip.
 *
 * Selective Edit needs these markers to re-identify branches/steps/answers
 * when parsing the TSV back. The user-facing Export Text view must not show
 * them — they are an implementation detail of Selective Edit.
 */
const ID_SUFFIX_PATTERN = /\t__(?:bid|sid|aid):\d+/g;

export function stripIdSuffixes(tsv: string): string {
  return tsv.replace(ID_SUFFIX_PATTERN, '');
}
